// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"InputLabel_InputLabel__mhwri","InputLabelLabel":"InputLabel_InputLabelLabel__b-OyX","InputLabelValue":"InputLabel_InputLabelValue__15T_k"};